"use client";

import { Route as UnknownRoute } from "@faire/web/ui/routing/Route";
import React from "react";

import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { LazyLoggedInHome } from "@faire/retailer/views/home/logged-in-homepage/LazyLoggedInHome";
import { LazyLoggedOutHomePage } from "@faire/retailer/views/home/logged-out-homepage";

export const RenderHomePage = () => (
  <UnknownRoute component={getHomepageComponent()} />
);

const getHomepageComponent = () => {
  if (!isLoggedInRetailer()) {
    return LazyLoggedOutHomePage;
  }
  return LazyLoggedInHome;
};
